import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';

/* "Did anything come of it?" — 14 days after claiming a perk or asking to talk
   to an advertiser (and again at 45 if still talking). One tap. */
export default function OutcomeAsk({ notify }) {
  const [data, setData] = useState(null);
  const [value, setValue] = useState('');
  const [note, setNote] = useState('');

  useEffect(() => { api.adFollowups().then(setData).catch(() => {}); }, []);
  if (!data || !data.due?.length) return null;
  const due = data.due[0];

  async function answer(kind) {
    try {
      await api.adOutcome(due.ad_id, { kind, value_bucket: value, note: note.trim(), round: due.round });
      notify?.('Thanks — that helps.');
      setValue(''); setNote('');
      setData({ ...data, due: data.due.slice(1) });
    } catch (e) { notify?.(e.message); }
  }

  const positive = ['signed_up', 'customer', 'funding', 'hired', 'partnered'];
  return (
    <section className="card pad outcome-ask">
      <b>Did anything come of {due.name}?</b>
      <p className="muted-sm">You looked into it through B/N. One tap — it helps us show members better offers.</p>
      <div className="oa-row">
        {Object.entries(data.outcomes).map(([k, label]) => (
          <button key={k} className={`btn sm ${positive.includes(k) ? 'ghost' : 'quiet'}`} onClick={() => answer(k)}>{label}</button>
        ))}
      </div>
      <details>
        <summary className="muted-sm">Add a rough value or a note (optional)</summary>
        <div className="oa-row">
          {Object.entries(data.values).map(([k, label]) => (
            <label key={k} className="notif-row"><input type="radio" name="oa-value" checked={value === k}
              onChange={() => setValue(k)} /> <span>{label}</span></label>
          ))}
        </div>
        <input className="in" maxLength={500} value={note} placeholder="What happened? (optional)"
          onChange={(e) => setNote(e.target.value)} />
        <p className="muted-sm">Pick an answer above to send it.</p>
      </details>
    </section>
  );
}
